import { useEffect } from "react";
import type { TFunction } from "i18next";
import { buildCausesToOffer } from "../selectors";
import { CauseType } from "../../../types/models";

export type CauseTypeLike = {
  archived?: boolean;
  id?: string;
  [key: string]: unknown;
};

type UseCheckInCausesToOfferLoaderParams = {
  causes: unknown[] | null | undefined;
  activeCauseTypes: CauseTypeLike[] | null | undefined;
  activeTeamCauseTypes: CauseTypeLike[] | null | undefined;
  defaultCauseTypes: CauseTypeLike[] | null | undefined;
  feelingName: string | null;
  selectedDate: string | Date | null;
  t: TFunction;
  setCausesToOffer: (c: CauseType[]) => void;
  setCausesLoading: (v: boolean) => void;
  /** Bump to refetch causes to offer (same as previous `updateCauses` state). */
  updateCauses: number | boolean;
};

export function useCheckInCausesToOfferLoader({
  causes,
  activeCauseTypes,
  activeTeamCauseTypes,
  defaultCauseTypes,
  feelingName,
  selectedDate,
  t,
  setCausesToOffer,
  setCausesLoading,
  updateCauses,
}: UseCheckInCausesToOfferLoaderParams) {
  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setCausesLoading(true);

        let teamOk: CauseTypeLike[] = [
          ...(Array.isArray(activeCauseTypes) ? activeCauseTypes : []),
          ...(Array.isArray(activeTeamCauseTypes) ? activeTeamCauseTypes : []),
        ];

        teamOk = teamOk.filter((item) => item.archived === false);

        teamOk = [
          ...teamOk,
          ...(Array.isArray(defaultCauseTypes) ? defaultCauseTypes : []),
        ];

        const data = await buildCausesToOffer(
          causes || [],
          teamOk || [],
          feelingName,
          t,
          [],
          activeTeamCauseTypes || [],
          selectedDate
        );

        if (!cancelled) {
          setCausesToOffer(Array.isArray(data) ? data : []);
        }
      } catch (e) {
        console.error("buildCausesToOffer failed:", e);
        if (!cancelled) setCausesToOffer([]);
      } finally {
        if (!cancelled) setCausesLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [
    JSON.stringify(causes),
    JSON.stringify(activeCauseTypes),
    JSON.stringify(defaultCauseTypes),
    feelingName,
    JSON.stringify(activeTeamCauseTypes),
    selectedDate,
    updateCauses,
    t,
    setCausesLoading,
    setCausesToOffer,
  ]);
}
